import Stack from "@mui/joy/Stack";

import TaskContextMenu from "../TaskCard/ContextMenu";
import { TaskSetCardSections } from "./TaskSetCardSection";
import TaskSetOverviewMenu from "./TaskSetOverviewMenu";

export default function TaskSetOverview() {
  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: 0,
        flexBasis: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <TaskSetOverviewMenu />
      <TaskSetCardSections />
      <TaskContextMenu />
    </Stack>
  );
}
